import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="editor_table-a"
            d="M14,3 L14,5 L2,5 L2,3 L2,13 L14,13 L14,3 Z M2,2 L14,2 C14.5522847,2 15,2.41327562 15,2.92307692 L15,13.0769231 C15,13.5867244 14.5522847,14 14,14 L2,14 C1.44771525,14 1,13.5867244 1,13.0769231 L1,2.92307692 C1,2.41327562 1.44771525,2 2,2 Z M2,7 L14,7 L14,8 L2,8 L2,7 Z M2,10 L14,10 L14,11 L2,11 L2,10 Z"/>
    </defs>
    <g>
      <use xlinkHref="#editor_table-a"/>
    </g>
  </svg>
);
